import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query VimeoUserSearch ($id: ID!, $limit: Int, $offset: Int, $value: Value) {
      VimeoUserSearch (id: $id, limit: $limit, offset: $offset, value: $value) {
        limit
        offset
        totalItems
        VimeoUserInfos {
          ...vimeoUserDetail
          pictures {
            ...vimeoPictureDetail
          }
          websites {
            ...vimeoWebsiteDetail
          }
          metadata {
            connections {
              videos {
                ...vimeoMetadataDetail
              }
            }
          }
        }
      }
    }
    ${fragments.vimeoUserDetail}
    ${fragments.vimeoPictureDetail}
    ${fragments.vimeoWebsiteDetail}
    ${fragments.vimeoMetadataDetail}
  `
